import React, { Component } from "react";
import { Votes } from "../../components/features/Votes";
import { withRouter } from "react-router-dom";

class VotesContainer extends Component {
  state = {
    votes: [],
    votesLoaded: false
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribe = window.firebase
      .firestore()
      .collection("features")
      .doc(this.props.featureId)
      .collection("votes")
      .onSnapshot(querySnapshot => {
        let votes = [];
        querySnapshot.forEach(function(doc) {
          let vote = doc.data();
          vote[".key"] = doc.id;
          votes.push(vote);
        });
        this.setState({ votes: votes, votesLoaded: true });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
  };

  handleVoteClick = (e, type) => {
    window.firebase
      .firestore()
      .collection("features")
      .doc(this.props.featureId)
      .collection("votes")
      .doc(this.props.user.uid)
      .set({ type: type });
  };

  render() {
    let votesPerType = {
      0: [],
      1: [],
      2: []
    };

    let userVoted = null;

    this.state.votes.forEach(vote => {
      votesPerType[vote.type].push(vote);
      if (vote[".key"] === this.props.user.uid) {
        userVoted = vote.type;
      }
    });
    return (
      <Votes
        votes={this.state.votes}
        handleVoteClick={this.handleVoteClick}
        votesPerType={votesPerType}
        userVoted={userVoted}
      />
    );
  }
}

export default withRouter(VotesContainer);
